import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { delay, filter, Subject } from 'rxjs';

@Directive({
  selector: '[appOnscrollAnimated]',
  standalone: true,
})
export class OnscrollAnimatedDirective
  implements OnDestroy, OnInit, AfterViewInit
{
  @Input() threshold = 0.0;
  @Input() clesses: string[] = [
    'animate-fade-up',
    'animate-once',
    'animate-duration-500',
    'animate-delay-500',
  ];

  @Output() visible = new EventEmitter<HTMLElement>();

  private observer: IntersectionObserver | undefined;
  private subject$ = new Subject<{
    entry: IntersectionObserverEntry;
    observer: IntersectionObserver;
  }>();

  constructor(private element: ElementRef) {}

  ngOnInit() {
    this.createObserver();
  }

  ngAfterViewInit() {
    this.startObservingElements();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }

    //this.subject$.next({} as any);
    this.subject$.complete();
  }

  private createObserver() {
    const options = {
      rootMargin: '0px',
      threshold: this.threshold,
    };

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.subject$.next({ entry, observer });
        }
      });
    }, options);
  }

  private startObservingElements() {
    if (!this.observer) {
      return;
    }

    this.observer.observe(this.element.nativeElement);

    this.subject$.subscribe(async ({ entry, observer }) => {
      const target = entry.target as HTMLElement;

      this.clesses.forEach((element) => {
        entry.target.classList.add(element);
      });
      this.visible.emit(target);
      observer.unobserve(target);
    });
  }
}
